var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{attrs:{"colspan":_vm.colspan}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('p',{staticClass:"body-1",staticStyle:{"text-align":"center","padding":"15px 0"}},[_vm._v(" Users of this table can pass in any component to show for the expanded content. ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }